module.exports = __webpack_public_path__ + "img/solutionBanner5.7f6ac4ec.png";